/**
 * Autogenerated file don't modify
 */
(function () {
(function () {
    'use strict';

    MoyaEventHandler.on('store.variantSelectionInit', function (data) {
        // check for disaled checked variants
        var hasDisabledRadio = document.querySelector('.variant-selection input[type=radio]:checked');
        if (hasDisabledRadio !== null && hasDisabledRadio.disabled) {
            var radios = document.querySelectorAll('.variant-selection input[type=radio]:not(:checked):not(:disabled)');
            if (radios !== null) {
                var done_1 = false;
                radios.forEach(function (radio) {
                    if (!done_1) {
                        radio.click();
                        done_1 = true;
                    }
                });
            }
        }
    });
    MoyaEventHandler.on('store.variantSelectionReplaceHTML', function (data) {
        function updateStock(stock, elm) {
            if (stock > 0) {
                elm.classList.add('inStock');
                elm.querySelector('.value').innerHTML = 'Til á lager';
            }
            else {
                elm.classList.remove('inStock');
                elm.querySelector('.value').innerHTML = 'Uppselt';
            }
        }
        function replaceURLParams(url, newMessage) {
            var urlObj = new URL(url, location.protocol + '//' + location.host);
            var safeNewMessage = encodeURIComponent(newMessage);
            urlObj.searchParams.set('message', safeNewMessage);
            return urlObj.toString();
        }
        var current = data.variantSelection.getSelectedVariant();
        var extraInfo = current.el.querySelector('.extraInfo');
        var stockHfj = Number(extraInfo.getAttribute('data-hfj'));
        var stockAkr = Number(extraInfo.getAttribute('data-akr'));
        updateStock(stockAkr, document.querySelector('.stock-info .item:first-of-type'));
        updateStock(stockHfj, document.querySelector('.stock-info .item:last-of-type'));
        var inquiryButton = document.querySelector('.btn-inquiry');
        inquiryButton.href = replaceURLParams(inquiryButton.href, 'Fyrirspurn um ' + current.el.dataset.label);
        inquiryButton.dataset.href = replaceURLParams(inquiryButton.dataset.href, 'Fyrirspurn um ' + current.el.dataset.label);
    });

}());
typeof tsBuild === 'function' && tsBuild();})();
